import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { pagesList, setting } from "../app/schema";

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_ERROR = "GET_SETTINGS_ERROR";

export const GET_SETTING = "GET_SETTING";
export const GET_SETTING_SUCCESS = "GET_SETTING_SUCCESS";
export const GET_SETTING_ERROR = "GET_SETTING_ERROR";

export const POST_SETTINGS = "POST_SETTINGS";
export const POST_SETTINGS_SUCCESS = "POST_SETTINGS_SUCCESS";
export const POST_SETTINGS_ERROR = "POST_SETTINGS_ERROR";

export const DELETE_SETTING = "DELETE_SETTING";
export const DELETE_SETTING_SUCCESS = "DELETE_SETTING_SUCCESS";
export const DELETE_SETTING_ERROR = "DELETE_SETTING_ERROR";

// Validation
const validateForm = {
  createSetting: (validate, fields, oneField) =>
    validate(fields, oneField) // .prop('name', 'Nazwa').required()
      .getErrors().promise
};

// Requests

const getSettingsGet = (fetch, apiHost, accessToken, meta) =>
  fetch(`${apiHost}/v1/settings?limit=${meta.limit}&offset=${meta.offset}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const getSettingGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/settings/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postSettings = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/settings`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteSetting = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/settings/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg:
          "Nie można usunąć danych ustawień, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function getSettings(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_SETTINGS],
    payload: {
      promise: getSettingsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { pagesLists: arrayOf(setting) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getSetting(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_SETTINGS],
    payload: {
      promise: getSettingGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, setting);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        uid
      }
    }
  });
}

export function createSetting(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_SETTINGS],
    payload: {
      promise: validateForm["createSetting"](validate, data)
        .then(() =>
          postSettings(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          )
        )
        .then(data => {
          return normalize(data, setting);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeSetting(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_SETTING],
    payload: {
      promise: deleteSetting(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

// Standard functions
export function validateFormFieldSettings(form, name, value) {
  const feature = "settings";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/settingsApi/actions.js